(function ($) {
    $(function () {
        function changeArrowPosition(event, slick, currentSlide, nextSlide) {
            var slideNumber = currentSlide ? currentSlide : 0;
            var $currentSlide = $(slick.$slides[slideNumber]);
            var $nextArrow = slick.$nextArrow;
            var $prevArrow = slick.$prevArrow;
            var top = $currentSlide.find('.teaser-image').outerHeight() / 2 -
                $prevArrow.outerHeight() / 2 +
                parseInt($currentSlide.find('.teaser').css('padding-top')) / 2;
            $nextArrow.css('top', top + "px");
            $prevArrow.css('top', top + "px");
        }

        $('.news-teaser-slider').on('afterChange', changeArrowPosition);
        $('.news-teaser-slider').on('init', changeArrowPosition);

        $('.news-teaser-slider').slick({
            slidesToShow: 3,
            swipeToSlide: false,
            dots: false,
            adaptiveHeight: true,
            autoplay: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                }]
        });

    });
})(window.jQuery);